import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import ClinicDetailsForm from '@src/pages/Admin/ClinicDetails/ClinicDetailsForm';
import { getClinic } from '@src/api';
import { formatPhoneForTable } from '@src/pages/Admin/utils/formatters';
import { useImpersonation } from '@src/contexts/ImpersonationContext';
const ClinicDetails = () => {
    const { user } = useAuth();
    const { impersonatedClinic } = useImpersonation();
    const clinicId = impersonatedClinic?.id || user?.defaultClinic?.id;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [clinic, setClinic] = useState(null);
    const [editFormData, setEditFormData] = useState({
        name: '',
        street_1: '',
        street_2: '',
        city: '',
        state: '',
        postal_code: '',
        phone: '',
        alternate_phone: '',
        email: '',
        fax: '',
        is_corporation_owned: false,
        corporation_name: '',
        buying_groups: {
            psi: false,
            verticalVet: false,
            vmg: false,
            tvc: false,
            other: false,
            otherText: ''
        },
        termsAccepted: false,
        hasShippingAddress: false,
        shipping_street_1: '',
        shipping_street_2: '',
        shipping_city: '',
        shipping_state: '',
        shipping_postal_code: ''
    });
    useEffect(() => {
        const fetchClinic = async () => {
            if (!clinicId)
                return;
            try {
                setLoading(true);
                const response = await getClinic(clinicId);
                const data = response.body;
                setClinic(data);
                if (data) {
                    const address = typeof data.address === 'object' && data.address ? data.address : {};
                    const billingAddressRaw = data.billingAddress || data.billing_address;
                    const billingAddress = typeof billingAddressRaw === 'object' && billingAddressRaw ? billingAddressRaw : {};
                    const hasShipping = billingAddress &&
                        typeof billingAddress === 'object' &&
                        Object.keys(billingAddress).length > 0 &&
                        (billingAddress.street1 || billingAddress.street_1 || billingAddress.street2 || billingAddress.street_2 ||
                            billingAddress.city || billingAddress.state || billingAddress.postalCode || billingAddress.postal_code);
                    setEditFormData({
                        name: data.name || '',
                        street_1: address.street1 || address.street_1 || '',
                        street_2: address.street2 || address.street_2 || '',
                        city: address.city || '',
                        state: address.state || '',
                        postal_code: address.postalCode || address.postal_code || '',
                        phone: (typeof data.phone === 'object' && data.phone?.formattedNumber) || formatPhoneForTable(data) || '',
                        alternate_phone: (typeof data.alternatePhone === 'object' && data.alternatePhone?.formattedNumber) || formatPhoneForTable({ ...data, phone: data.alternatePhone }) || '',
                        email: data.email || '',
                        fax: (typeof data.fax === 'object' && data.fax?.formattedNumber) || (data.fax ? formatPhoneForTable({ ...data, phone: data.fax }) : ''),
                        is_corporation_owned: data.isCorporationOwned || data.is_corporation_owned || false,
                        corporation_name: data.customCorporationName || data.custom_corporation_name || data.corporateGroup?.name || data.corporate_group?.name || '',
                        buying_groups: {
                            psi: data.buyingGroups?.includes('PSI') || data.buying_groups?.includes('PSI') || false,
                            verticalVet: data.buyingGroups?.includes('Vertical Vet') || data.buying_groups?.includes('Vertical Vet') || false,
                            vmg: data.buyingGroups?.includes('VMG') || data.buying_groups?.includes('VMG') || false,
                            tvc: data.buyingGroups?.includes('TVC') || data.buying_groups?.includes('TVC') || false,
                            other: data.buyingGroups?.some((g) => !['PSI', 'Vertical Vet', 'VMG', 'TVC'].includes(g)) || data.buying_groups?.some((g) => !['PSI', 'Vertical Vet', 'VMG', 'TVC'].includes(g)) || false,
                            otherText: data.buyingGroups?.find((g) => !['PSI', 'Vertical Vet', 'VMG', 'TVC'].includes(g)) || data.buying_groups?.find((g) => !['PSI', 'Vertical Vet', 'VMG', 'TVC'].includes(g)) || ''
                        },
                        termsAccepted: false,
                        hasShippingAddress: !!hasShipping,
                        shipping_street_1: billingAddress.street1 || billingAddress.street_1 || '',
                        shipping_street_2: billingAddress.street2 || billingAddress.street_2 || '',
                        shipping_city: billingAddress.city || '',
                        shipping_state: billingAddress.state || '',
                        shipping_postal_code: billingAddress.postalCode || billingAddress.postal_code || ''
                    });
                }
            }
            catch (err) {
                setError('Failed to load clinic details');
                console.error(err);
            }
            finally {
                setLoading(false);
            }
        };
        fetchClinic();
    }, [clinicId]);
    return (_jsx("div", { style: { marginTop: "8em", marginBottom: "2em" }, children: _jsx(ClinicDetailsForm, { clinicId: clinicId, formData: editFormData, onSetFormData: setEditFormData, onSetClinic: setClinic }) }));
};
export default ClinicDetails;
